import { connect } from 'react-redux';

import {
  setFoodProfilePopupStep,
  toggleFoodProfilePopup,
} from '../actions/foodProfilePopup';
import {
  persistFoodProfile,
  createFoodProfile,
} from '../actions/foodProfile';
import FoodProfilePopup from '[theme-lib]/apps/foodProfile/components/FoodProfilePopup';

export default connect(
  (state) => ({
    isPopupOpened: state.foodProfilePopup.isPopupOpened,
    currentStep: state.foodProfilePopup.currentStep,
    profile: state.foodProfile.profile,
    conditions: state.foodProfile.profileConditions,
  }), {
    setFoodProfilePopupStep,
    toggleFoodProfilePopup,
    persistFoodProfile,
    createFoodProfile,
  }
)(FoodProfilePopup);
